module.exports = "<div ng-bind-html=\"match.label | gwTypeaheadHighlight:query\"\n     ng-attr-title=\"{{match.label}}\"></div>\n"